// extracted by mini-css-extract-plugin
module.exports = {"destinationList":"DestinationList_destinationList__3HhPv","destinationImageLink":"DestinationList_destinationImageLink__20V66"};